import { Component, inject } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { CapturumButtonModule } from '@capturum/ui/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-info-dialog',
    template: `
    <p class="msg mb-4">{{ message }}</p>

    <div class="dialog-footer d-flex justify-content-center">
      <cap-button
        styleClass="secondary mr-4"
        [label]="'LeadPortal.form.callbacks.confirm' | translate"
        (onClick)="close()"></cap-button>
    </div>
  `,
    imports: [DialogModule, CapturumButtonModule, TranslateModule],
    styles: [
        `
      .msg {
        padding: 5px;
        font-size: 1rem;
        white-space: pre-line;
        line-height: 1.3rem;
        font-weight: 500;
      }
    `,
    ]
})
export class InfoDialogComponent {
  private readonly dynamicDialogRef = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);

  public message: string = this.config.data?.message;

  public close(): void {
    this.dynamicDialogRef.close();
  }
}
